import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    // Salva uma medição do contrato
    async saveQueryOnColigada({ commit }, data) {
      try {
        return await api.post(`/queries/relations`, data)
      } catch (error) {
        throw error
      }
    },

    // Listagem das queries do sistema, junto com sua relação
    async getQueriesSystem({ commit }, data) {
      try {
        const response = await api.get(`/queries/system`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    // Listagem das queries do sistema, junto com sua relação
    async getQueriesByColigada({ commit }, data) {
      try {
        const response = await api.get(`/queries/relations`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    // Listagem das queries do sistema, junto com sua relação
    async getQueriesTotvs({ commit }, data) {
      try {
        const response = await api.get(`/queries/totvs`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
